import { Component, OnInit } from '@angular/core';
import { VERSION } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-version-info',
  template: `<div
    *ngIf="showVersion"
    style="position: fixed; bottom: 5px; right: 5px; font-size: 10px; color: #ccc;"
  >
    Angular: {{ angularVersion }}
  </div>`,
  standalone: true,
  imports: [NgIf],
})
export class VersionInfoComponent implements OnInit {
  angularVersion = VERSION.full;
  showVersion = false;

  ngOnInit() {
    // Only show in specific circumstances, like a query param or admin user
    this.showVersion = location.search.includes('debug=true');

    // Always log to console for easier checking
    console.log('Angular version:', VERSION.full);
  }
}
